export default __webpack_public_path__ + "static/media/2.72634b48.webp";